import bootLayout from 'static/script/app/boot/boot-layout'

module.exports = initData => {
    bootLayout(initData);
};


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/pages/category-list.js